//service
import http from "./httpService";
import config from "./config"



// //register user
// export const registerUser = user => {
//     return http.post(
//         `${config.apiAddress}user/register`,
//         JSON.stringify(user)
//     );
// };


//products 
export const products = () => {
    return http.get(
        `${config.apiAddress}product/products`,
    );
};
//products 
export const product = (address) => {
    return http.get(
        `${config.apiAddress}product/product/${address}`,
    );
};

//tags 
export const tags = () => {
    return http.get(
        `${config.apiAddress}product/tags`
    );
};

//catgories 
export const catgories = () => {
    return http.get(
        `${config.apiAddress}product/categories`
    );
};
